import apiService from './apiService';

export const performLogout = (clearUserData) => {
  apiService.clearAffiliateFundsCache();
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('affiliateCode');
  localStorage.removeItem('authToken');
  localStorage.removeItem('currentRoute');
  localStorage.removeItem('userData');
  localStorage.removeItem('userPermissions');
  clearUserData?.();
  window.dispatchEvent(new CustomEvent('loginStateChanged'));
};
